import React from 'react';
import type { Preview } from '@/modules/topic/preview';

// Extracted verbatim from ComposeWithTemplate.tsx (#447) so news steps can
// reuse the SMS link-card preview.

export const SMSLinkPreviewCard: React.FC<{ preview: Preview }> = ({
  preview,
}) => (
  <div
    className="section-card__sms-link-preview"
    data-testid="sms-link-preview"
  >
    <img
      alt=""
      className="section-card__sms-link-preview-image"
      src={preview.image}
    />
    <div className="section-card__sms-link-preview-body">
      <div className="section-card__sms-link-preview-title">
        {preview.title}
      </div>
      <div className="section-card__sms-link-preview-url">
        {displayPreviewURL(preview.url)}
      </div>
    </div>
  </div>
);

function displayPreviewURL(value: string): string {
  if (!value) return '';

  try {
    return new URL(value).host;
  } catch {
    return value.replace(/^https?:\/\//i, '').split('/')[0] ?? value;
  }
}
